export const GAME_TITLE = "Conexões";
export const INFO_MODAL_MS = 350
export const MAX_MISTAKES = 4;
export const DIFFICULTY_COLOR_MAP = {
    1: "rgba(255, 190, 159, 1)",
    2: "rgba(128, 224, 167, 1)",
    3: "rgba(249, 229, 71, 1)",
    4: "rgba(193, 167, 226, 1)",
};
